import { Location } from "react-router";

export const getCategoryFromQuery = (location: Location<any>) => {
  const params = new URLSearchParams(location.search);
  const category = params.get("category");
  return category === "male" ? "male" : "female";
};
